export interface SidebarNavConfig {
  title: string;
  icon?: string;
  routerLink?: any;
  exactMatchLink?: boolean;
  disabled?: boolean;
}
